export const comments_3324440 = {"data":{"data":[],"links":{}}}